import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';

const MailingList = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className="relative overflow-hidden py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-blue-200 text-sm font-medium mb-6">
          <Mail className="w-4 h-4 mr-2" />
          Newsletter
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold text-white">
          Get export insights, course drops, and event invites.
        </h2>
        <p className="mt-4 text-lg text-slate-300">
          One thoughtful email a month. Unsubscribe any time.
        </p>

        <form
          onSubmit={handleSubmit}
          className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <input
            type="email"
            required
            className="flex-1 rounded-lg px-4 py-3 bg-white/10 border border-white/20 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-500 text-white font-semibold transition-colors"
          >
            Subscribe
            <ArrowRight className="ml-2 h-5 w-5" />
          </button>
        </form>
      </div>
    </section>
  );
};

export default MailingList;